import React from 'react';
import { SocialIcon } from '@components/SocialIcon';
import { IconButton } from '@components/IconButton';
import { IconPaperplane, IconArrowForward, IconEdit } from '@components/icons';
import styles from './WhatsappCard.module.scss';

export interface WhatsappCardProps {
  /** Contact name or phone number */
  name: string;
  /** Subtitle text (e.g., "Whatsapp") */
  subtitle?: string;
  /** Whether the contact has been contacted */
  contacted?: boolean;
  /** Click handler for the action button */
  onAction?: () => void;
  /** Click handler for the edit button */
  onEdit?: () => void;
  /** Additional CSS classes */
  className?: string;
}

export const WhatsappCard: React.FC<WhatsappCardProps> = ({
  name,
  subtitle = 'Whatsapp',
  contacted = false,
  onAction,
  onEdit,
  className = '',
}) => {
  const containerClass = [
    styles.container,
    contacted ? styles.contacted : styles.notContacted,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClass}>
      <div className={styles.contactInfo}>
        <SocialIcon provider="whatsapp" className={styles.icon} />
        <div className={styles.content}>
          <p className={styles.name}>{name}</p>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        {onEdit && (
          <IconButton
            size="small"
            aria-label="Edit WhatsApp number"
            onClick={onEdit}
            className={styles.editButton}
          >
            <IconEdit size={14} />
          </IconButton>
        )}
      </div>
      <div className={styles.footer}>
        <button
          type="button"
          className={styles.actionButton}
          onClick={onAction}
        >
          {contacted ? (
            <>
              <span className={styles.actionText}>Open Chat</span>
              <IconArrowForward size={14} color="currentColor" />
            </>
          ) : (
            <>
              <IconPaperplane size={17} color="currentColor" />
              <span className={styles.actionText}>Reach Out</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};
